export type SectionHeadingsHi = {
  significance: string;
  story: string;
  vidhi: string;
  samagri: string;
  regional: string;
  dates: string;
  faq: string;
  week: string;
  readMore: string;
  upNext: string;
};

const POOJA = 'पूजा';

export function sectionHeadingsHi(name: string, year: number): SectionHeadingsHi {
  const poojaName = name.endsWith(POOJA) ? name : `${name} ${POOJA}`;
  return {
    significance: `${name} का महत्व`,
    story: `${name} की कथा`,
    vidhi: `घर पर ${poojaName} कैसे करें`,
    samagri: `${poojaName} सामग्री`,
    regional: 'क्षेत्रीय परंपराएँ',
    dates: `${name} की तिथियाँ`,
    faq: 'अक्सर पूछे जाने वाले प्रश्न',
    week: `दिवाली ${year}: दिन-प्रतिदिन`,
    readMore: 'और पढ़ें',
    upNext: 'आगे के त्योहार',
  };
}

export const ctaHeadingHi = (name: string) => `Dharmayana के साथ ${name} मनाएँ`;

export const languageSwitch = { toHindi: 'Read in Hindi', toEnglish: 'अंग्रेज़ी में पढ़ें' };

export const answerLabelsHi = { date: 'तारीख', tithi: 'तिथि', city: 'शहर', time: 'समय (IST)' };

export const pageTextHi = {
  home: 'होम',
  festivals: 'त्योहार',
  breadcrumb: 'नेविगेशन पथ',
  onThisPage: 'इस पेज पर:',
  day: 'दिन',
  date: 'तारीख',
  logoAlt: 'Dharmayana लोगो',
  appBanner: 'पूरे Dharmayana अनुभव के लिए',
};

export const timesForCityHi = (city: string) => `समय ${city} के लिए IST में हैं।`;

export const aboutHi = (name: string) => `${name} के बारे में`;
